import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import {
  cartBaseTranslationChunksConfig,
  cartBaseTranslationsDe,
  cartBaseTranslationsEn,
  cartBaseTranslationsJa,
  cartBaseTranslationsZh
} from '@spartacus/cart/base/assets'
import {
  ADD_TO_CART_FEATURE,
  CART_BASE_FEATURE,
  CartBaseRootModule,
  MINI_CART_FEATURE
} from '@spartacus/cart/base/root'
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core'
@NgModule({
  declarations: [],
  imports: [CommonModule, CartBaseRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [CART_BASE_FEATURE]: {
          cmsComponents: [
            'CartApplyCouponComponent',
            'CartProceedToCheckoutComponent',
            'SaveForLaterComponent',
            'ClearCartComponent'
          ],
          module: () =>
            import('../../../features/cart/eb-cart-feature.module').then(m => m.EbCartFeatureModule)
        },
        ebCartPage: {
          cmsComponents: ['CartComponent', 'CartTotalsComponent'],
          dependencies: [CART_BASE_FEATURE],
          module: () =>
            import('../../../features/cart/eb-cart-page.module').then(m => m.EbCartPageModule)
        },
        ebQuickOrder: {
          cmsComponents: ['QuickOrderComponent'],
          dependencies: [CART_BASE_FEATURE],
          module: () =>
            import('../../../features/cart/eb-quick-order.module').then(m => m.EbQuickOrderModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      featureModules: {
        [MINI_CART_FEATURE]: {
          module: () =>
            import('@spartacus/cart/base/components/mini-cart').then(m => m.MiniCartModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      featureModules: {
        [ADD_TO_CART_FEATURE]: {
          module: () =>
            import('@spartacus/cart/base/components/add-to-cart').then(m => m.AddToCartModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {
          en: cartBaseTranslationsEn,
          ja: cartBaseTranslationsJa,
          de: cartBaseTranslationsDe,
          zh: cartBaseTranslationsZh
        },
        chunks: cartBaseTranslationChunksConfig
      }
    } as I18nConfig)
  ]
})
export class CartBaseFeatureModule {}
